import React from 'react';
import { formatApiDisplayText } from '../utils/visaFormHelpers';
import CountrySelect from './CountrySelect';

const VisaFormField = ({ field, value, onChange, readOnly = false }) => {
  const inputClass = 'w-full border border-gray-200 rounded-lg px-3 py-2';

  if (readOnly) {
    return (
      <div className="w-full border border-gray-100 bg-gray-50 rounded-lg px-3 py-2 text-sm text-gray-700">
        {value || '-'}
      </div>
    );
  }

  if (field.type === 'textarea') {
    return (
      <textarea
        value={value || ''}
        onChange={(e) => onChange(field.name, e.target.value)}
        className={inputClass}
        rows={3}
        required={field.required}
      />
    );
  }

  if (field.type === 'radio' && Array.isArray(field.options) && field.options.length > 0) {
    return (
      <div className="space-y-2">
        {field.options.map((opt, idx) => {
          const optValue =
            typeof opt === 'object'
              ? formatApiDisplayText(opt.id || opt.value || opt.name)
              : formatApiDisplayText(opt);
          const optLabel =
            typeof opt === 'object'
              ? formatApiDisplayText(opt.name || opt.label || opt.id || opt.value)
              : formatApiDisplayText(opt);
          return (
            <label key={`${field.name}-${idx}`} className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="radio"
                name={field.name}
                value={optValue}
                checked={String(value || '') === String(optValue)}
                onChange={() => onChange(field.name, optValue)}
                required={field.required}
              />
              {optLabel || optValue}
            </label>
          );
        })}
      </div>
    );
  }

  if (field.type === 'country') {
    return (
      <CountrySelect
        value={value || ''}
        onChange={(next) => onChange(field.name, next)}
        placeholder="Select"
        emptyLabel="Select"
        required={field.required}
        buttonClassName="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-gray-900"
      />
    );
  }

  if (field.type === 'select' && Array.isArray(field.options)) {
    const looksLikeCountryField = /country|nationality|citizenship/i.test(
      String(field.name || field.label || '')
    );
    if (looksLikeCountryField) {
      return (
        <CountrySelect
          value={value || ''}
          onChange={(next) => onChange(field.name, next)}
          placeholder="Select"
          emptyLabel="Select"
          required={field.required}
          buttonClassName="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-gray-900"
        />
      );
    }

    return (
      <select
        value={value || ''}
        onChange={(e) => onChange(field.name, e.target.value)}
        className={inputClass}
        required={field.required}
      >
        <option value="">Select</option>
        {field.options.map((opt, idx) => {
          const optValue =
            typeof opt === 'object'
              ? formatApiDisplayText(opt.id || opt.value || opt.name)
              : formatApiDisplayText(opt);
          const optLabel =
            typeof opt === 'object'
              ? formatApiDisplayText(opt.name || opt.label || opt.id || opt.value)
              : formatApiDisplayText(opt);
          return (
            <option key={`${field.name}-${idx}`} value={optValue}>
              {optLabel || optValue}
            </option>
          );
        })}
      </select>
    );
  }

  return (
    <input
      type={field.type === 'date' ? 'date' : field.type === 'number' ? 'number' : field.type === 'email' ? 'email' : 'text'}
      value={value || ''}
      onChange={(e) => onChange(field.name, e.target.value)}
      className={inputClass}
      required={field.required}
    />
  );
};

export default VisaFormField;
